var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-link-container"},[(_vm.isSupported)?_c('button',{staticClass:"calendar-link no-style",on:{"click":_vm.getCalendarFile}},[_vm._v("Add to my Calendar")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }